/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiCreateGroupReservationRequestCallDetailFromJSON, StreemApiCreateGroupReservationRequestCallDetailToJSON, StreemApiGroupReservationDetailFromJSON, StreemApiGroupReservationDetailToJSON, } from './';
export function StreemApiCreateGroupReservationRequestFromJSON(json) {
    return StreemApiCreateGroupReservationRequestFromJSONTyped(json, false);
}
export function StreemApiCreateGroupReservationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'externalUserId': !exists(json, 'external_user_id') ? undefined : json['external_user_id'],
        'queue': !exists(json, 'queue') ? undefined : json['queue'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'reserveForSeconds': !exists(json, 'reserve_for_seconds') ? undefined : json['reserve_for_seconds'],
        'details': !exists(json, 'details') ? undefined : (json['details'].map(StreemApiGroupReservationDetailFromJSON)),
        'referenceId': !exists(json, 'reference_id') ? undefined : json['reference_id'],
        'integrationId': !exists(json, 'integration_id') ? undefined : json['integration_id'],
        'reconnectPreviousReservationSid': !exists(json, 'reconnect_previous_reservation_sid') ? undefined : json['reconnect_previous_reservation_sid'],
        'callDetail': !exists(json, 'call_detail') ? undefined : StreemApiCreateGroupReservationRequestCallDetailFromJSON(json['call_detail']),
        'previousReservationSid': !exists(json, 'previous_reservation_sid') ? undefined : json['previous_reservation_sid'],
        'reservationType': !exists(json, 'reservation_type') ? undefined : json['reservation_type'],
    };
}
export function StreemApiCreateGroupReservationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'external_user_id': value.externalUserId,
        'queue': value.queue,
        'priority': value.priority,
        'reserve_for_seconds': value.reserveForSeconds,
        'details': value.details === undefined ? undefined : (value.details.map(StreemApiGroupReservationDetailToJSON)),
        'reference_id': value.referenceId,
        'integration_id': value.integrationId,
        'reconnect_previous_reservation_sid': value.reconnectPreviousReservationSid,
        'call_detail': StreemApiCreateGroupReservationRequestCallDetailToJSON(value.callDetail),
        'previous_reservation_sid': value.previousReservationSid,
        'reservation_type': value.reservationType,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiCreateGroupReservationRequestReservationType;
(function (StreemApiCreateGroupReservationRequestReservationType) {
    StreemApiCreateGroupReservationRequestReservationType["ORIGIN"] = "RESERVATION_TYPE_ORIGIN";
    StreemApiCreateGroupReservationRequestReservationType["RECONNECT"] = "RESERVATION_TYPE_RECONNECT";
    StreemApiCreateGroupReservationRequestReservationType["REQUEUE"] = "RESERVATION_TYPE_REQUEUE";
    StreemApiCreateGroupReservationRequestReservationType["INVALID"] = "RESERVATION_TYPE_INVALID";
})(StreemApiCreateGroupReservationRequestReservationType || (StreemApiCreateGroupReservationRequestReservationType = {}));
//# sourceMappingURL=StreemApiCreateGroupReservationRequest.js.map